export default () => '9999.99.99'

